import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "classNames", "hidden"];
import { cx } from "../../lib/cx.js";
export function createAutocompletePanelComponent(_ref) {
  var createElement = _ref.createElement;
  return function AutocompletePanel(userProps) {
    var children = userProps.children,
      _userProps$classNames = userProps.classNames,
      classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames,
      hidden = userProps.hidden,
      props = _objectWithoutProperties(userProps, _excluded);
    return createElement("div", _extends({}, props, {
      "aria-hidden": hidden,
      className: cx('ais-AutocompletePanel', !hidden && 'ais-AutocompletePanel--open', classNames.root, props.className),
      onMouseDown: function onMouseDown(event) {
        // Prevents the autocomplete panel from blurring the input when
        // clicking inside the panel.
        event.preventDefault();
      }
    }), createElement("div", {
      className: cx('ais-AutocompletePanelLayout', classNames.layout)
    }, children));
  };
}